// src/components/SearchBar.js

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
const SearchBar = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [filteredCampaigns, setFilteredCampaigns] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch campaigns from the backend
    axios.get('/api/campaigns')
      .then(response => {
        setCampaigns(response.data.Data); // Assuming campaigns are in response.data.Data
      })
      .catch(error => {
        console.error('Error fetching campaigns:', error);
      });
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setSelectedCampaign(null);

    if (value) {
      const filtered = campaigns.filter(campaign =>
        campaign.text.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCampaigns(filtered);
      setShowSuggestions(true);
    } else {
      setFilteredCampaigns([]);
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (campaign) => {
    setInputValue(campaign.text);
    setSelectedCampaign(campaign);
    setFilteredCampaigns([]);
    setShowSuggestions(false);
    navigate(`/${campaign.value}`);
  };

  const handleSearch = () => {
    if (selectedCampaign) {
      navigate(`/${selectedCampaign.value}`);
    } else {
      alert('Please select a valid campaign from the suggestions.');
    }
  };

  // ... rest of the component remains the same ...


  return (
    <div className="flex justify-center my-4">
      <div className="w-full max-w-xs relative">
        <input
          type="text"
          placeholder="Enter Campaign ID"
          className="input input-bordered w-full"
          value={inputValue}
          onChange={handleInputChange}
          ref={inputRef}
        />
        {showSuggestions && (
          <ul className="absolute z-10 bg-white border border-gray-300 w-full mt-1 max-h-60 overflow-y-auto shadow-lg">
            {filteredCampaigns.length > 0 ? (
              filteredCampaigns.map(campaign => (
                <li
                  key={campaign.value}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleSuggestionClick(campaign)}
                >
                  {campaign.text}
                </li>
              ))
            ) : (
              <li className="px-4 py-2 text-gray-500">No campaigns found</li>
            )}
          </ul>
        )}
      </div>
      <button className="btn btn-primary ml-2" onClick={handleSearch}>
        Search
      </button>
    </div>
  );
};

export default SearchBar;
